/**
 * Resolve API base URL.
 *
 * Android Chrome blocks credentialed calls from https://acgsaletool.com to
 * https://www.acgsaletool.com (different Origins). When the baked API host is
 * only a www/apex variant of the current page, use same-origin `/api` instead
 * (proxied by server.js / nginx).
 */
const baked = (process.env.REACT_APP_API_URL || "/api").trim().replace(/\/$/, "") || "/api";

const stripWww = (hostname) => hostname.replace(/^www\./i, "").toLowerCase();

const resolveApiUrl = () => {
  if (typeof window === "undefined") {
    return baked;
  }

  if (baked.startsWith("/")) {
    return baked;
  }

  try {
    const api = new URL(baked, window.location.origin);
    if (stripWww(api.hostname) === stripWww(window.location.hostname)) {
      return "/api";
    }
    return baked;
  } catch (_) {
    return "/api";
  }
};

const apiUrl = resolveApiUrl();

export default apiUrl;
